// extracted by mini-css-extract-plugin
module.exports = {"whiteStyle":"e_VG","prefix":"e_WG","counter":"e_XG"};